/* @flow */

import React, { PureComponent } from 'react';
import i18n from 'app/common/lib/i18n';
import trackRegisterAction from 'app/common/lib/util/trackRegisterAction';
import { type UnauthSeoExperiments } from 'app/common/lib/react/withUnauthSeoExperiments';
import { Box, Button, Text, TextField } from 'gestalt';

type Props = {|
  onNotNowClick: () => void,
  email: string,
  emailError: string,
  handleEmailChange: ({ value: string }) => void,
  handleSubmit: () => void,
  seoUnauthExperiments: UnauthSeoExperiments,
|};

class FacebookEmailCollectionForm extends PureComponent<Props> {
  componentDidMount() {
    this.focusInputField();

    trackRegisterAction('unauth.fb_phone_only_signup.email_step');
  }

  inputRef = null;

  handleNotNowClick = () => {
    trackRegisterAction('unauth.fb_phone_only_signup.email_step.not_now_click');
    if (this.props.onNotNowClick) {
      this.props.onNotNowClick();
    }
  };

  focusInputField() {
    if (this.inputRef && this.inputRef.textfield) {
      this.inputRef.textfield.focus(); // HACK to access the textfield (<input>) element of a Gestalt TextField
    }
  }

  render() {
    // TODO: use this string to replace the one on line 58 once the translation is done
    i18n._(
      'We use your email address for account creation and for important security and legal notices.',
      'subtitle to explain the step on email collection form',
    );

    const { email, emailError, handleEmailChange, handleSubmit, seoUnauthExperiments } = this.props;
    const expGroup =
      seoUnauthExperiments.v2GetGroup('web_unauth_desktop_fb_phone_only_sign_up_v3') || '';
    const bodyText =
      expGroup.indexOf('copy_variant') === -1
        ? i18n._(
            "Oops. We're unable to create your account without your email. To continue, make sure" +
              ' you provide email to create your account.',
            'subtitle to explain the step on email collection form',
          )
        : i18n._(
            'We use your email address for account creation and for important security and legal notices.',
            'Description for email address in after sign in with apple',
          );
    return (
      <Box marginTop={3}>
        <form
          method="post"
          noValidate
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <Text align="left" overflow="normal">
            {bodyText}
          </Text>
          <Box marginTop={3} />
          <Box>
            <TextField
              id="email"
              errorMessage={emailError}
              onChange={handleEmailChange}
              placeholder={i18n._(
                'Email address',
                'email placeholder in the email inputfield on email collection form',
              )}
              ref={(c) => {
                this.inputRef = c;
              }}
              type="email"
            />
          </Box>
          <Box marginTop={5} />
          <Button
            color="red"
            text={i18n._('Continue', 'word on the button which to submit user email information')}
            type="submit"
            disabled={!email}
          />
          <Box marginTop={2} />
          <Button
            text={i18n._('Not now', 'word on not now button to dismiss the collection form')}
            type="submit"
            onClick={this.handleNotNowClick}
          />
        </form>
      </Box>
    );
  }
}

export default FacebookEmailCollectionForm;
